import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import logo from "../assets/logo.png";
import Typography from "@mui/material/Typography";
import circle from "../assets/Circle.svg";
import ex from "../assets/x.svg";
import square from "../assets/square.svg";
import triangle from "../assets/triangle.svg";

const FinishedScreen = () => {
  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            height: { xs: "250px", md: "205px" },
            width: { xs: "170px", md: "190px" },
            display: "flex",
            alignItems: "center",
            // justifyItems: "center",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              mt: { xs: "6em", md: "4em" },
            }}
          >
            <img
              src={logo}
              alt="this is a logo"
              width="50%"
              height="auto"
            ></img>
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              display: "flex",
              justifyContent: "space-evenly",
              width: "100%",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#591A68",
                width: "30px",
                height: "35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={circle} alt="this is a circle icon" width="50%"></img>
            </Box>
            <Box
              sx={{
                backgroundColor: "#591A68",
                width: "30px",
                height: "35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={ex} alt="this is a t-shaped icon" width="50%"></img>
            </Box>
            <Box
              sx={{
                backgroundColor: "#591A68",
                width: "30px",
                height: "35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={square} alt="this is a square icon" width="50%"></img>
            </Box>
            <Box
              sx={{
                backgroundColor: "#591A68",
                width: "30px",
                height: "35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={triangle}
                alt="this is a triangle icon"
                width="50%"
              ></img>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            backgroundColor: "#fff",
            textAlign: "center",
            padding: "40px 20px",
            margin: { xs: "7rem 1rem", md: "4rem 21rem" },
          }}
        >
          <Typography
            sx={{
              color: "#5C1B6B",
              fontWeight: 500,
              fontSize: { xs: "1rem", md: "1.2rem" },
            }}
          >
            Happy National Training Seminar! <br /> And
          </Typography>
          <Typography
            sx={{
              color: "#5C1B6B",
              textTransform: "uppercase",
              fontWeight: 600,
              fontSize: { xs: "1rem", md: "2rem" },
            }}
          >
            May the Odds be ever in your favor
          </Typography>
        </Box>

        <Typography
          sx={{
            fontWeight: 800,
            fontSize: "1.2rem",
          }}
        >
          19th - 24th October 2023
        </Typography>
      </Box>
    </Container>
  );
};

export default FinishedScreen;
